const API_URL = "https://pending.backend-tree.com/";

export async function auth(key) {
  try {
    const requestParams = {
      method: "GET"
    };

    const response = await fetch(`${API_URL}/auth_control_panel?key=${key}`, requestParams);
    const { success } = await response.json();

    return success;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
